<div class="migrations-container table-bottom-padding">
  @if (isRefreshing) {
    <div class="alert alert-info" [innerHTML]="'tkey;migrations.number_report.loading_alert' | escapeHtml"></div>
  }

  @if (isLoading || isRefreshing) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isRefreshing && !isLoading) {
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="140"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="mb-3" data-automation="migration-summary" [innerHTML]="utilizationSummary | escapeHtml"></div>
    <ziro-datatable
      #datatable
      [columns]="columns"
      [rowDataSource]="data"
      [uniqueRowIdentifier]="'id'"
      [mainFilterPlaceholder]="'tkey;migrations.number_report.table.filter.placeholder' | translate"
      [dataAutomation]="tableDataAutomation"
      [stickyColumnCount]="3"
      [isColumnVisibilityFilterVisible]="true"
      [columnVisibilityFilterOptions]="groupedColumnFilterOptions"
      [columnVisibilityFilterInitialOptions]="initialGroupedColumnFilterOptions"
      [resetPageOnDataChange]="false"
      [showCustomAlert]="showCustomAlert"
      [showSelectColumn]="true"
      [setColumnWidths]="true"
      [tooltipPlacement]="'auto'"
      [showValidationMessageInTooltip]="true"
      (rowSelected)="onRowSelected()"
      (searchResultsChanged)="onTableResultsChanged()"
      [class]="'ziro-card'"
    >
      <ziro-datatable-multi-select-filter
        #migrationStatusFilter
        [label]="'tkey;migrations.ring_central.numbers_report.table.migration_status.label'"
        [items]="migrationStatusOptionsWithCounts"
        [matchFn]="migrationStatusMatchFn"
        [dataAutomation]="'migration-status-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
        (isInitialized)="onFilterInitialized()"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #lineTypeFilter
        [label]="'tkey;migrations.ring_central.numbers_report.table.usage_type.label'"
        [items]="lineTypeOptionsWithCounts"
        [matchFn]="lineTypeMatchFn"
        [dataAutomation]="'line-type-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
        (isInitialized)="onFilterInitialized()"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #deviceTypeFilter
        [label]="'tkey;migrations.ring_central.numbers_report.table.device_type.label'"
        [items]="deviceTypeOptionsWithCounts"
        [matchFn]="deviceTypeMatchFn"
        [dataAutomation]="'device-type-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
        (isInitialized)="onFilterInitialized()"
      ></ziro-datatable-multi-select-filter>
      <ziro-datatable-multi-select-filter
        #siteFilter
        [label]="'tkey;migrations.ring_central.numbers_report.table.site.label'"
        [items]="siteOptionsWithCounts"
        [matchFn]="siteMatchFn"
        [dataAutomation]="'site-filter'"
        [tableId]="tableDataAutomation"
        [showRowCount]="true"
      ></ziro-datatable-multi-select-filter>
      <div class="text-center" alert-content>
        {{ 'tkey;migrations.number_report.table.job_status.error.table_message_pre' | translate }}
        <button
          data-automation="custom-alert-button"
          class="btn btn-border btn-link strong align-baseline"
          (click)="onRefreshClick()"
          [innerHTML]="'tkey;migrations.number_report.table.job_status.error.table_message_link.label' | escapeHtml"
        ></button>
      </div>
    </ziro-datatable>
  }
  <ng-template #deviceUsageTypeCell let-row="row">
    @let icon = getDeviceUsageTypeIcon(row);

    <span class="alert alert-inline alert-info">
      @if (icon && isIconStacked(icon)) {
        <ziro-stacked-icon
          [stackedIcon]="ZiroStackedIcons[icon]"
          parentClass="fa-stack text-secondary w-auto"
        ></ziro-stacked-icon>
      } @else if (icon) {
        <i class="{{ icon }} text-secondary"></i>
      }
      <span>
        {{ getDeviceUsageTypeLabel(row) }}
      </span>
    </span>
  </ng-template>
</div>
